<div class="support-container">
  <sh-text class="support-header">
    Need Assistance? We're Here to Help
  </sh-text>

  <sh-text class="support-description">
    Whether you're having trouble logging in, activating your license, or
    navigating the ExpertGuidance App, our support team is ready to assist you
    every step of the way.
  </sh-text>

  <div class="support-contact">
    <sh-icon icon="envelope" size="s"></sh-icon>
    <sh-text class="support-label">Email Us</sh-text>
  </div>

  <div class="support-email">
    <div>
      <sh-text class="email-text"
        >ies-support.func&#64;siemens-healthineers.com</sh-text
      >
    </div>
    <div>
      <sh-icon
        id="target-1"
        icon="copy-results-to-clipboard"
        size="s"
        (click)="copyEmailToClipboard()"
        style="cursor: pointer"
      ></sh-icon>
    </div>
    <sh-tooltip
      target="target-1"
      [label]="tooltipLabel"
      placement="right"
    ></sh-tooltip>
  </div>
</div>

<div class="footer-links">
  <sh-span>©Siemens Healthineers AG - 2025 |</sh-span>
  <a href="https://www.siemens-healthineers.com/" target="_blank"
    >Siemens Healthineers Global Website</a
  >
  <a href="https://www.siemens-healthineers.com/cookie" target="_blank"
    >Cookie Policy</a
  >
  <a href="https://www.siemens-healthineers.com/corporate-info" target="_blank"
    >Corporate Information</a
  >
  <a
    href="https://www.siemens-healthineers.com/corporate/digital-services-act"
    target="_blank"
    >Digital Services Act</a
  >
</div>
